import { Component } from 'react';
import { Alert, Button } from '@carboledger/ui';
import styles from './ErrorBoundary.module.scss';
import { getTranslation } from '@/lib/utils/i18n';

// App-level error boundary.
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // TODO: forward to an error-reporting service (Sentry) once wired.
    if (import.meta.env.DEV) console.error('ErrorBoundary caught:', error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className={styles.fallback}>
          <Alert
            variant="danger"
            title={getTranslation('ERROR_TITLE')}
            action={
              <Button variant="secondary" onClick={this.reset}>
                {getTranslation('ACTION_TRY_AGAIN')}
              </Button>
            }
          >
            {getTranslation('ERROR_UNEXPECTED_BODY')}
          </Alert>
        </div>
      );
    }
    return this.props.children;
  }
}
